const Recipe = {

    // FIELDS
    recipe_title: 'Recipe Title',
    recipe_image: 'Recipe Image',
    category: 'Category',
    difficulty: 'Difficulty',
    preparation_time: 'Preparation Time',
    recipe_description: 'Description',
    recipe_status: 'Approval Status',
    status: 'Status',
    product: 'Product',
    product_code: 'Product Code',
    product_name: 'Product Name',
    search: 'Search',
    created_at: 'Created At',
    ingredient: 'Ingredient',
    instruction: 'Instruction',

    // PAGE HEADER
    recipe: 'Recipe',
    basic_info: 'Basic Info',
    products_info: 'Linked Products',
    products_empty: 'No linked products available',
    ingredients_info: 'Ingredients',
    ingredients_empty: 'No ingredients available',
    instructions_info: 'Instructions',
    instructions_empty: 'No instructions available',
    details_error: 'Unable to load recipe details',

    // TABLE HEADERS
    table_image: 'IMAGE',
    table_recipe_title: 'RECIPE TITLE',
    table_category: 'CATEGORY',
    table_product: 'PRODUCT',
    table_difficulty: 'DIFFICULTY',
    table_preparation_time: 'PREP TIME',
    table_recipe_status: 'APPROVAL STATUS',
    table_user: 'USER',
    table_email: 'EMAIL',
    table_mobile: 'MOBILE',
    table_created_at: 'CREATED AT',

    // USER INFO
    user_info: 'Submitted By',
    user_name: 'Name',
    user_email: 'Email',
    user_mobile: 'Mobile',

    // ACTION BUTTONS
    approve: 'Approve',
    reject: 'Reject',

    // CONFIRMATIONS
    confirm_approve_title: 'Approve Recipe?',
    confirm_approve_text: 'This recipe will be marked as approved.',
    confirm_reject_title: 'Reject Recipe?',
    confirm_reject_text: 'This recipe will be marked as rejected.',

    approved_success: 'Recipe Approved.',
    rejected_success: 'Recipe Rejected.',

    // STATUS LABELS
    status_pending: 'Pending',
    status_approved: 'Approved',
    status_rejected: 'Rejected',
}

export default Recipe;